import styled from 'styled-components';
import {theme} from '@styles/theme';

export const PlansList = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: ${theme.colors.basic07};
  padding: 8px;
  border-radius: ${theme.roundedMedium};
`;

export const PlanItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
`;

export const PlanItemActions = styled.div`
  display: flex;
  align-items: center;
`;
